import React from 'react';
import PropTypes from 'prop-types';

// Table custom (from scratch) — remplace la Table de reactstrap.
// Reproduit fidèlement les classes générées par reactstrap pour conserver
// un rendu identique : `table`, `table-{size}`, `table-bordered`,
// `table-borderless`, `table-striped`, `table-dark`, `table-hover`, et le
// wrapper `.table-responsive` quand `responsive` est fourni.
const Table = ({
  className,
  size,
  bordered,
  borderless,
  striped,
  dark,
  hover,
  responsive,
  tag: Tag = 'table',
  responsiveTag: ResponsiveTag = 'div',
  innerRef,
  children,
  ...otherProps
}) => {
  const classes = [
    'app-table',
    'table',
    size && `table-${size}`,
    bordered && 'table-bordered',
    borderless && 'table-borderless',
    striped && 'table-striped',
    dark && 'table-dark',
    hover && 'table-hover',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const table = (
    <Tag ref={innerRef} className={classes} {...otherProps}>
      {children}
    </Tag>
  );

  if (responsive) {
    const responsiveClassName = responsive === true ? 'table-responsive' : `table-responsive-${responsive}`;

    return <ResponsiveTag className={responsiveClassName}>{table}</ResponsiveTag>;
  }

  return table;
};

Table.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  className: PropTypes.string,
  size: PropTypes.string,
  bordered: PropTypes.bool,
  borderless: PropTypes.bool,
  striped: PropTypes.bool,
  dark: PropTypes.bool,
  hover: PropTypes.bool,
  responsive: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  responsiveTag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),
};

export default Table;
